const DeveloperContent = [
  {
    name: "Vaibhav Garg",
    links: [
      {
        name: "Github",
        href: "https://github.com/21VAibhavGArg",
      },
      {
        name: "Linkedin",
        href: "https://linkedin.com/in/vaibhavgarg24",
      },
    ],
  },
  {
    name: "Divyanshu Sharma",
    links: [
      {
        name: "Github",
        href: "https://github.com/d1vshar",
      },
      {
        name: "Linkedin",
        href: "https://linked.com/in/d1vshar/",
      },
    ],
  },
  {
    name: "Shubham Ranga",
    links: [
      {
        name: "Github",
        href: "https://github.com/shubhamrangaa",
      },
      {
        name: "Linkedin",
        href: "https://linkedin.com/in/shubhamrangaa/",
      },
    ],
  },
  {
    name: "Manavendra Sen",
    links: [
      {
        name: "Github",
        href: "https://github.com/manavendrasen",
      },
      {
        name: "Linkedin",
        href: "https://linkedin.com/in/manavendrasen/",
      },
    ],
  },
];

export default DeveloperContent;
